import React from 'react';
import { Paper, Typography } from '@mui/material';
import styled from 'styled-components';
import { BusinessNumber, CustomerNumber } from '../../types';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '../common/Table';

interface CustomerNumbersTableProps {
    title: string;
    businessNumbers: BusinessNumber[];
    limit: number;
    page: number;
    handleChangePage: any;
    handleChangeRowsPerPage: any;
}

const StyledCustomerNumbersTable = styled.div`
    .no-numbers-style {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
`;
const CustomerNumbersTable: React.FC<CustomerNumbersTableProps> = ({ title, businessNumbers }) => {
    return (
        <StyledCustomerNumbersTable id="customer-business-numbers-div" className="mb-5">
            <Typography id="customer-business-numbers-title" className="text-2xl mb-2">
                {`Customer ${title} Numbers`}
            </Typography>
            <Paper>
                {businessNumbers && businessNumbers.length ? (
                    <TableContainer id="customer-business-numbers-table-container">
                        <Table
                            id="customer-business-numbers-table"
                            aria-label="simple table"
                            size="small"
                        >
                            <TableHead id="customer-business-numbers-table-head">
                                <TableRow id="customer-business-numbers-table-row">
                                    <TableCell align="left">Number</TableCell>
                                    <TableCell align="left">Owned By</TableCell>
                                    <TableCell align="left">Used By</TableCell>
                                    <TableCell align="left">Minutes remaining</TableCell>
                                    <TableCell align="left">Credit Type</TableCell>
                                    <TableCell align="left">Credit Plan</TableCell>
                                    <TableCell align="left">Credit Limit Type</TableCell>
                                    <TableCell align="left">Credit Group</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody id="customer-business-numbers-table-body">
                                {businessNumbers.map((business: BusinessNumber, index: number) =>
                                    business.numbers.map((number: CustomerNumber) => (
                                        <>
                                            <TableRow
                                                id={`customer-business-numbers-businessname-row-${index}`}
                                                key={business.businessId}
                                            >
                                                <TableCell
                                                    colSpan={9}
                                                    component="th"
                                                    scope="row"
                                                    className="text-center font-bold capitalize py-1 bg-gray-200"
                                                >
                                                    {business.businessName}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow
                                                id={`customer-business-numbers--row-${index}`}
                                                key={number.number}
                                            >
                                                <TableCell align="left">{number.number}</TableCell>
                                                <TableCell align="left">
                                                    {number.ownedByDesc}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {number.usedByDesc}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {number.minsOwed > 0
                                                        ? -number.minsOwed
                                                        : number.minsPaid}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {number.creditType}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {number.creditPlanName}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {number.minLimitType}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {number.creditGroupName}
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )),
                                )}
                            </TableBody>
                        </Table>
                        {/* <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={40}
                                rowsPerPage={limit}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            /> */}
                    </TableContainer>
                ) : (
                    <div id="no-numbers-div" className="no-numbers-style p-4">
                        {`No ${title} Numbers`}
                    </div>
                )}
            </Paper>
        </StyledCustomerNumbersTable>
    );
};

export default React.memo(CustomerNumbersTable);
